<template>
  <div class="page logistics">
    <Nav></Nav>
    <v-container class="page-content mt-8 mb-8 px-4 ">
      <v-row>
        <v-col class="col-12 pa-0">
          <Card class="mb-6">
            <SearchFilter></SearchFilter>
          </Card>
          <Card>
            <Tabs :list="logisticsItems" head-left-title="项目名称" headCenterTitle="公司" head-right-title="发布时间"></Tabs>
          </Card>
        </v-col>
      </v-row>
    </v-container>
    <CFooter></CFooter>
  </div>
</template>

<script>
import CFooter from '@/components/Common/Footer'
import { Card, Tabs } from '@/components/UI'
import SearchFilter from '@/components/Logistics/SearchFilter'
import { LogisticsTab } from '@/mixins/logistics'
export default {
  name: 'Logistics',
  mixins: [LogisticsTab],
  components: {
    CFooter,
    Card,
    Tabs,
    // TabItem,
    SearchFilter
  },
  data: () => {
    return {
      tab: 0
    }
  },
  methods: {
  },
  async created () {
  }
}
</script>

<style lang="scss" scoped>

</style>
